// src/slices/menuStat.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'lib/axios';

// Define the initial state
const initialState = {
    stats: {
        registeredUsersCount: 0,
        unseenMessageCount: 0
    },
    status: 'idle',
    error: null,
    unseenSenders: [] // Use array instead of Set to avoid Immer MapSet plugin requirement
};

// Create an async thunk to fetch menu stats
export const fetchMenueStat = createAsyncThunk('menu-stats', async () => {
    const { data } = await axios.get('/menu-stats');
    return data.menus_stats;
});

// Create the menuStat slice
const menuStat = createSlice({
    name: 'menuStat',
    initialState,
    reducers: {
        updateMenueStat: (state, action) => {
            state.stats = { ...state.stats, ...action.payload };
        },
        updateUnseenMessageCount: (state, action) => {
            state.stats.unseenMessageCount = action.payload;
        },
        addUnseenSender: (state, action) => {
            // Add sender to array if not already present
            if (!state.unseenSenders.includes(action.payload)) {
                state.unseenSenders.push(action.payload);
                state.stats.unseenMessageCount = state.unseenSenders.length;
            }
        },
        removeUnseenSender: (state, action) => {
            // Remove sender from array
            const index = state.unseenSenders.indexOf(action.payload);
            if (index > -1) {
                state.unseenSenders.splice(index, 1);
                state.stats.unseenMessageCount = state.unseenSenders.length;
            }
        },
        clearUnseenSenders: (state) => {
            state.unseenSenders = [];
            state.stats.unseenMessageCount = 0;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchMenueStat.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMenueStat.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.stats = action.payload;
            })
            .addCase(fetchMenueStat.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
    }
});

export const { updateMenueStat, updateUnseenMessageCount, addUnseenSender, removeUnseenSender, clearUnseenSenders } = menuStat.actions;

export default menuStat.reducer;
